import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CampaignObject,
  CharacterItem,
  CharacterSpell,
  DandDFeatureSource,
  PseudoItem,
  SummonOption2,
} from "@dndModels";
import { ModelBase, PlayerObject } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import DisplayObject from "@dndComponents/display/DisplayObject";
import DeleteButton from '@components/input/buttons/icon_buttons/DeleteButton';
import FlexBox from '@components/layout/FlexBox';

interface Props {
  obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem;
  getName?: (obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  onSelect: () => void;
  onDelete: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function ListOptionsRow({
  obj,
  getName,
  onSelect,
  onDelete
}: Props) {
  // const [reloading, setReloading] = useState(false);

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    if (obj instanceof DandDFeatureSource) {
      const colors = char_util.getColors({ user: api.user, for_id: obj._id, source: obj });
      return ({
        root: {
          color: colors.color,
          backgroundColor: colors.backgroundColor,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '4px',
          marginBottom: '4px',
        }
      });
    } else {
      // console.log(theme);
      return ({
        root: {
          backgroundColor: theme.palette.secondary.main,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '4px',
          marginBottom: '4px',
        },
      });
    }
  });

  const { classes, cx } = useStyles();
  
  return (
    <FlexBox direction="row" className={cx(classes.root, "padded")}>
      <FlexBox className="clickable" onClick={() => { onSelect(); }}>
        { getName ? getName(obj) : <DisplayObject obj={obj} display_variant /> }
      </FlexBox>
      <FlexBox xs_expand={0}>
        <div style={{ float: "right" }}>
          <DeleteButton
            no_fab
            obj_name={obj.name}
            onClick={onDelete}
          />
        </div>
      </FlexBox>
    </FlexBox>
  );
}
